/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CanvasCellPresenterBase } from "./CanvasCellPresenterBase";
import { SectionHeaderCellModel } from "./SectionHeaderCellModel";
import { markType } from "igniteui-react-core";
import { CanvasContentCellModelHelper } from "./CanvasContentCellModelHelper";
/**
 * @hidden
 */
var CanvasSectionHeaderCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CanvasSectionHeaderCellPresenter, _super);
    function CanvasSectionHeaderCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(CanvasSectionHeaderCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    CanvasSectionHeaderCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (a.as) {
            if (a.ax(SectionHeaderCellModel.k2) || a.ax(SectionHeaderCellModel.k4)) {
                if (b.ky == null || (b.ky.length == 0 && b.lc == null)) {
                    if (b.gp == null) {
                        b.ir = "";
                    }
                    else {
                        b.ir = b.gp.toString();
                    }
                }
                else {
                    if (b.la != null && b.k1 == 0) {
                        b.ir = b.lc + "    " + b.la;
                    }
                    else {
                        b.ir = b.lc;
                    }
                }
                this.d.ck(b.ir);
            }
            CanvasContentCellModelHelper.a(this.a.bl, b, this.a);
        }
    };
    CanvasSectionHeaderCellPresenter.$t = markType(CanvasSectionHeaderCellPresenter, 'CanvasSectionHeaderCellPresenter', CanvasCellPresenterBase.$);
    return CanvasSectionHeaderCellPresenter;
}(CanvasCellPresenterBase));
export { CanvasSectionHeaderCellPresenter };
//# sourceMappingURL=CanvasSectionHeaderCellPresenter.js.map
